// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 添加自选板块 POST /my-block/add */
export async function myBlockAddUsingPOST(
  body: API.MyBlockAddReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/my-block/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取自选板块列表 GET /my-block/list */
export async function myBlockListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListMyBlockResp>('/my-block/list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 删除自选板块 POST /my-block/remove */
export async function myBlockRemoveUsingPOST(
  body: API.MyBlockRemoveReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/my-block/remove', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
